import { render, staticRenderFns } from "./ReporteStockCrud.vue?vue&type=template&id=6b176af2"
import script from "./ReporteStockCrud.vue?vue&type=script&lang=js"
export * from "./ReporteStockCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports